var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimalisticMagnifer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2077 4.35449C10.5562 4.35449 4.35352 10.5572 4.35352 18.2087C4.35352 25.8601 10.5562 32.0628 18.2077 32.0628C25.8591 32.0628 32.0618 25.8601 32.0618 18.2087C32.0618 10.5572 25.8591 4.35449 18.2077 4.35449ZM1.97852 18.2087C1.97852 9.24554 9.24456 1.97949 18.2077 1.97949C27.1708 1.97949 34.4368 9.24554 34.4368 18.2087C34.4368 27.1718 27.1708 34.4378 18.2077 34.4378C9.24456 34.4378 1.97852 27.1718 1.97852 18.2087ZM30.8263 30.8273C31.2901 30.3636 32.042 30.3636 32.5057 30.8273L35.6724 33.994C36.1361 34.4577 36.1361 35.2096 35.6724 35.6733C35.2086 36.1371 34.4567 36.1371 33.993 35.6733L30.8263 32.5067C30.3626 32.0429 30.3626 31.291 30.8263 30.8273Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimalisticMagnifer);
export default __webpack_public_path__ + "static/media/Minimalistic Magnifer.1ef1da6096467292fec9098709e8c077.svg";
export { ForwardRef as ReactComponent };